function repositionStore() {
  if ($(".store-block").length) {
    var storeBlock = $(".store-block");
    $(storeBlock).insertBefore("#footer");

    $(".custom-footer__banner16").remove();
  }
}
